<template>
    <b-overlay
        :no-fade="noFade"
        :no-wrap="noWrap"
        :opacity="opacity"
        :rounded="rounded"
        :show="loading || show"
        :spinner-type="spinnerType"
        :variant="color"
        :z-index="zIndex"
    >
        <slot />
    </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
    components: { BOverlay },
    computed: {
        loading() {
            return this.getLoading() > 0
        }
    },
    methods: {
        ...mapGetters([ 'getLoading' ]),
    },
    props: {
        color: { type: String, default: 'white' },
        noFade: { type: Boolean, default: false },
        noWrap: { type: Boolean, default: false },
        opacity: { type: [Number, String], default: 0.85 },
        rounded: { type: [Boolean, String], default: false },
        show: { type: Boolean, default: false },
        spinnerType: { type: String, default: 'border' },
        zIndex: { type: [Number, String], default: 998 },
    },
}
</script>